/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetFaqList200Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetFaqList200ResponseFromJSON,
  GetFaqList200ResponseToJSON,
} from '../models/index'

/**
 * FaqApi - interface
 *
 * @export
 * @interface FaqApiInterface
 */
export interface FaqApiInterface {
  /**
   * Общие частые вопросы личного кабинета (только записи с meta.extra.is_common = true; сортировка по meta.extra.sort_order). Остальные вопросы доступны только в привязке к инструкциям. Требуется подтверждённый email.
   * @summary Список частых вопросов
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FaqApiInterface
   */
  getFaqListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetFaqList200Response>>

  /**
   * Общие частые вопросы личного кабинета (только записи с meta.extra.is_common = true; сортировка по meta.extra.sort_order). Остальные вопросы доступны только в привязке к инструкциям. Требуется подтверждённый email.
   * Список частых вопросов
   */
  getFaqList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetFaqList200Response>
}

/**
 *
 */
export class FaqApi extends runtime.BaseAPI implements FaqApiInterface {
  /**
   * Общие частые вопросы личного кабинета (только записи с meta.extra.is_common = true; сортировка по meta.extra.sort_order). Остальные вопросы доступны только в привязке к инструкциям. Требуется подтверждённый email.
   * Список частых вопросов
   */
  async getFaqListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetFaqList200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/faq`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetFaqList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Общие частые вопросы личного кабинета (только записи с meta.extra.is_common = true; сортировка по meta.extra.sort_order). Остальные вопросы доступны только в привязке к инструкциям. Требуется подтверждённый email.
   * Список частых вопросов
   */
  async getFaqList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetFaqList200Response> {
    const response = await this.getFaqListRaw(initOverrides)
    return await response.value()
  }
}
